const DateService = {
	months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	formatDate: function(YYYYMMDD) {
		let year = +YYYYMMDD.slice(0, 4);
		let month = +YYYYMMDD.slice(4, 6) - 1;
		let day = +YYYYMMDD.slice(6);
		return `${this.months[month]} ${day}, ${year}`;
	}
}
export default DateService;